import { supabase } from '@/integrations/supabase/client';
import { bytesToBase64 } from '../../supabase/functions/_shared/clientConsentDeclaration';

export async function registerUploadedContactList(campaignId: string, file: File): Promise<{ id: string; sha256: string }> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  const { data, error } = await supabase.functions.invoke('upload-campaign-contact-list', {
    body: {
      campaign_id: campaignId,
      file_name: file.name,
      file_base64: bytesToBase64(bytes),
    },
  });
  if (error) throw error;
  const payload = data && typeof data === 'object' ? data as { sha256?: unknown; id?: unknown } : {};
  const sha256 = String(payload.sha256 ?? '');
  const id = String(payload.id ?? '');
  if (!/^[a-f0-9]{64}$/.test(sha256) || !id) {
    throw new Error('The contact list hash was not recorded, so the list was not uploaded.');
  }
  return { id, sha256 };
}

/** Service-role insert. The signed-in user cannot write campaign_client_consent_records. */
export async function saveManagedClientConsent(rows: Record<string, unknown>[]): Promise<{ error: string | null }> {
  const campaignId = typeof rows[0]?.campaign_id === 'string' ? rows[0].campaign_id : '';
  const contactListId = typeof rows[0]?.contact_list_id === 'string' ? rows[0].contact_list_id : '';
  const { data, error } = await supabase.functions.invoke('store-campaign-client-consent', {
    body: { campaign_id: campaignId, contact_list_id: contactListId, records: rows },
  });
  if (error) {
    const message = data && typeof data === 'object' && 'error' in data
      ? String((data as { error?: unknown }).error ?? '')
      : error.message;
    return { error: message || 'Client consent records could not be stored, so nothing was imported.' };
  }
  if (data && typeof data === 'object' && 'error' in data && (data as { error?: unknown }).error) {
    return { error: String((data as { error: unknown }).error) };
  }
  return { error: null };
}
